"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var link_1 = __importDefault(require("next/link"));
var image_1 = __importDefault(require("next/image"));
var apps_shared_1 = require("@l2p/apps-shared");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Provider = function (_a) {
    var slug = _a.slug, title = _a.title;
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var _b = (0, react_1.useState)("/img/providers/".concat(slug, ".svg")), imgSrc = _b[0], set_imgSrc = _b[1];
    (0, react_1.useEffect)(function () {
        set_imgSrc("/img/providers/".concat(slug, ".svg"));
    }, [slug]);
    return (react_1.default.createElement(link_1.default, { className: styles_module_scss_1.default.container, href: generateUrlWithLang("/providers/".concat(slug.toLowerCase())) },
        react_1.default.createElement(image_1.default, { width: 80, height: 80, loading: "lazy", src: imgSrc, alt: title, onError: function () {
                set_imgSrc("/img/providers/default.svg");
            } })));
};
exports.default = Provider;
